module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-02-ipad-content.48e5c081.png";